<section>

  <div id="customPopup" class="custom-popup">
    <div class="custom-popup-content">
      <button class="custom-popup-close" id="closeButton">
        <span>x</span>
      </button>
      <div class="popup-header">
        <h2 class="popup-title">Delete Economy</h2>
      </div>
      <hr class="popup-divider" />
      <p class="popup-message">Are you sure, you want to delete?</p>
      <div class="popup-buttons">
        <button class="popup-container  small opened" id="deleteButton">Ok</button>
        <button class="popup-container  small opened" id="cancelButton">Cancel</button>
      </div>
    </div>
  </div>

  <div class="mid_container add_economy">
    <div class=" mid_container_inner ">
      <div class="comman_mid_wraper">
        <div class="admin_wraper">
          <div class="comman_box">
            <div *ngFor="let economy of economy_sequences ; let economy_index = index" class="economy_class"><br>
              <div class="economy_action_row">
                <label class=" col-sm-12 col-xs-12 no_pad">Economy {{economy.name}} : </label>
                <button *ngIf="is_default_economy(economy)" (click)="save_economy(economy_index)"
                  [disabled]="economy_saved[economy_index]" class="btn btn-xs btn-primary"> Save </button>
                <button *ngIf="is_default_economy(economy)" (click)="delete(economy_index)"
                  class="btn btn-xs btn-primary">{{economy.id ? 'Delete' : 'Remove'}}</button>
                <a *ngIf="economy.id" target="_blank" [href]="economy.pdf_link"> (PDF)</a>
              </div>
              <div><input *ngIf="economy.created_by === 'user'" type="text" class="add_economy_note" name="note"
                  [(ngModel)]="economy.note" placeholder="Description"></div>
              <div *ngFor="let econ_value of economy.eseq_values_attributes; let eseq_val_index = index"
                class="economy_value">
                <input type="text" [hidden]="check_dec_index(eseq_val_index)"
                  [disabled]="economy.created_by === 'system'" [(ngModel)]="econ_value.econ_value" maxlength='2'
                  class="econ_value"
                  [ngClass]="eseq_values_error[economy_index][eseq_val_index].includes('econ_value')? 'form_validation_error': ''" />
              </div>
              <!-- <button (click)="save_economy(economy_index)" class="btn btn-primary comman_btn "> Save </button>
                <button (click)="delete_economy(economy_index)" class="btn btn-primary comman_btn ">Delete</button> -->
              <hr size="1">
            </div>
            <a href="javascript:void(0)" *ngIf="check_economy_length() && econ_added.length==0" class="custom_icon"><i
                class="fa fa-plus-square" aria-hidden="true" (click)="addNewEconomy()"></i></a>
            <div class="row ">
              <div class="col-lg-12"> <a href="javascript:void(0)" (click)="redirectToSessionControl()"
                  class="btn btn-primary comman_btn  ">Go Back</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>